function linkHtml(href: string, label: string): string {
  const isInternal = href.startsWith("/") && !href.startsWith("//");
  if (isInternal) {
    return `<a href='${href}' class='text-brand hover:underline'>${label}</a>`;
  }
  return `<a href='${href}' class='text-brand hover:underline' target='_blank' rel='noopener'>${label}</a>`;
}

function markdownToHtml(
  md: string,
  paragraphClass: string,
  listItemClass: string,
): string {
  let html = md
    .replace(/^### (.+)$/gm, "<h3 class='text-base font-semibold text-foreground mt-4 mb-2'>$1</h3>")
    .replace(/^## (.+)$/gm, "<h2 class='text-lg font-bold text-foreground mt-5 mb-2'>$1</h2>")
    .replace(/^# (.+)$/gm, "<h1 class='text-xl font-bold text-foreground mt-5 mb-3'>$1</h1>")
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/\*(.+?)\*/g, "<em>$1</em>")
    .replace(/`(.+?)`/g, "<code class='rounded bg-muted/30 px-1 py-0.5 text-xs font-mono'>$1</code>")
    .replace(/\[(.+?)\]\((.+?)\)/g, (_m, label: string, href: string) =>
      linkHtml(href, label),
    )
    .replace(/^- (.+)$/gm, `<li class='ml-4 ${listItemClass}'>$1</li>`)
    .replace(/^---$/gm, "<hr class='my-4 border-border' />")
    .replace(/\n\n/g, `</p><p class='${paragraphClass}'>`)
    .replace(/\n/g, "<br />");
  return `<p class='${paragraphClass}'>${html}</p>`;
}

/** Minimal markdown → HTML for pipeline AI output. */
export function renderMarkdown(md: string): string {
  return markdownToHtml(
    md,
    "text-muted-foreground leading-relaxed text-sm",
    "text-muted-foreground",
  );
}

/** Markdown → HTML for assistant chat (foreground body text). */
export function renderAssistantMarkdown(md: string): string {
  return markdownToHtml(
    md,
    "text-foreground leading-relaxed text-sm",
    "text-foreground",
  );
}
